import { Field } from '@base-ui/react/field';
import { Fieldset } from '@base-ui/react/fieldset';
import { Input } from '@/components/ui/Input';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { useIntegrationsSettings } from '@/providers/settings/SettingsContext';

export const IntegrationsSection = () => {
  const {
    discord,
    linkedinCookie,
    mark,
    setDiscord,
    setLinkedinCookie,
    setShowLI,
    showLI,
    threshold,
  } = useIntegrationsSettings();

  return (
    <Fieldset.Root>
      <Fieldset.Legend render={<SectionHeader>Integrations</SectionHeader>} />
      <div className="space-y-4">
        <Field.Root className="block">
          <div className="mb-1.5 flex items-baseline justify-between">
            <Field.Label className="text-sm lg:text-base font-medium text-foreground">
              Discord webhook
            </Field.Label>
            <Field.Description className="font-mono text-xs lg:text-sm text-subtle">
              for new-match pings
            </Field.Description>
          </div>
          <Input
            font="mono"
            onChange={(e) => mark(setDiscord)(e.target.value)}
            placeholder="https://discord.com/api/webhooks/…"
            size="sm"
            value={discord}
          />
          <p className="mt-1.5 font-mono text-xs lg:text-sm text-subtle">
            Sends an embed for any job scoring ≥{threshold}.
          </p>
        </Field.Root>
        <Field.Root className="block">
          <div className="mb-1.5 flex items-baseline justify-between">
            <Field.Label className="text-sm lg:text-base font-medium text-foreground">
              LinkedIn{' '}
              <code className="rounded bg-surface border border-border px-1 py-0.5 font-mono text-xs lg:text-sm text-foreground">
                li_at
              </code>{' '}
              cookie
            </Field.Label>
            <Field.Description className="font-mono text-xs lg:text-sm text-subtle font-bold">
              Required for LinkedIn scraper
            </Field.Description>
          </div>
          <div className="relative">
            <Input
              autoComplete="off"
              className="pr-16"
              font="mono"
              onChange={(e) => mark(setLinkedinCookie)(e.target.value)}
              size="sm"
              type={showLI ? 'text' : 'password'}
              value={linkedinCookie}
            />
            <button
              aria-label={showLI ? 'Hide li_at cookie' : 'Show li_at cookie'}
              className="absolute top-1/2 right-1.5 -translate-y-1/2 rounded-sm px-2 py-0.5 font-mono text-xs lg:text-sm text-foreground-muted transition-colors hover:bg-border/40 hover:text-foreground"
              onClick={() => setShowLI((s) => !s)}
              type="button"
            >
              {showLI ? 'hide' : 'show'}
            </button>
          </div>
          <p className="mt-1.5 font-mono text-xs lg:text-sm text-subtle">
            Found in DevTools → Application → Cookies → www.linkedin.com →{' '}
            <code className="rounded bg-surface border border-border px-1 py-0.5 font-mono text-xs lg:text-sm text-foreground">
              li_at
            </code>
            .
          </p>
        </Field.Root>
      </div>
    </Fieldset.Root>
  );
};
